export default {
  routerBase: {
    'a1': 'Family',
    'a2': 'Bind account',
    'a3': 'New family members',
    'a4': 'Edit Family',
    'a5': 'Add record',
    'a6': 'Dirty sound',
    'a7': 'Number of steps',
    'a8': 'hrv',
    'a9': 'Apnea',
    'a10': 'Blood pressure',
    'a11': 'Glucose',
    'a12': 'Heart rate',
    'a13': 'ECG',
    'a14': 'Heart load',
    'a15': 'Blood Oxygen',
    'a16': 'Arteriosclerosis Index',
    'a17': 'sos warning',
    'a18': 'Health analysis',
    'a19': 'BMI'
  }
}
